import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IMobileSecuritySettingsResult } from '../types/IMobileSecuritySettings';

export class GetMobileSecuritySettingsForServerRequest extends Request<{}, IMobileSecuritySettingsResult> {
    constructor() {
        super('getMobileSecuritySettingsForServer', {});
    }
}
